import { render, staticRenderFns } from "./EmployeeDetailsCardOperator.vue?vue&type=template&id=c5f161b0&"
import script from "./EmployeeDetailsCardOperator.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetailsCardOperator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports